import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { GetFlightCampaignsData, getFlightCampaigns } from '~/services/FlightsService';

export const FLIGHT_CAMPAIGNS_QUERY_KEY = 'flightCampaigns';

export function useFlightCampaigns(filters: GetFlightCampaignsData = {}, enabled = true) {
  const {
    data = { rows: [], count: 0 },
    isLoading: loading,
    error,
    refetch,
  } = useQuery<{ rows: Array<App.FlightCampaign>; count: number }, Error>({
    queryKey: [FLIGHT_CAMPAIGNS_QUERY_KEY, filters],
    queryFn: async ({ signal }) => {
      const { result } = await getFlightCampaigns(filters, { signal });
      return result;
    },
    enabled,
    placeholderData: keepPreviousData,
  });

  return { loading, error, data: data.rows, total: data.count, revalidate: refetch };
}
